<template>
  <div class="service">
    <prismic-rich-text class="service__title"
                       :field="nameService"/>
    <div class="service__wrapper">
      <template v-for="(partner, index) in partners">
        <div class="service__wrapper__content"
             :key="index">
          <prismic-image class="service__wrapper__content__img"
                         :field="partner.image" />
          <div class="service__wrapper__content__description">
            <prismic-rich-text class="service__wrapper__content__description__text"
                               :field="partner.title"/>
            <toggle :moreText="$t(`perks.partner.buttonMore`)"
                    :lessText="$t(`perks.partner.buttonLess`)">
              <prismic-rich-text class="service__wrapper__content__description__toggle"
                                 :field="partner.content"/>
            </toggle>
            <el-link
                v-if="partner.link && partner.link.value"
                class="service__wrapper__content__description__button
                     button-link
                     el-button--success"
                :underline="false"
                target="_blank"
                :href="partner.link.value.url">
              {{$t('perks.partner.buttonTakeAdvantage')}}
            </el-link>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Toggle from '@/utils/components/Toggle.vue';

export default {
  name: 'ServiceCard',
  components: {
    Toggle,
  },
  props: {
    partners: [Object, Array],
    nameService: [Object, Array],
  },
};
</script>

<style lang="scss" scoped>
.service {
  :deep(h3), :deep(h4), :deep(p), :deep(span) {
    color: inherit;
    font-size: inherit;
  }
  &__title {
    font-family: "futura-pt", "Helvetica Neue", Helvetica, sans-serif;
    font-weight: 700;
    font-size: 18px;
    color: $--color-primary;
    padding-top: 70px;
    margin-top: -50px;
    padding-bottom: 20px;
  }
  &__wrapper {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 20px;
    @include breakpoint(tablet) {
      grid-template-columns: repeat(2, 1fr);
    }
    @include breakpoint(desktop) {
      grid-template-columns: repeat(3, 1fr);
    }
    &__content {
      max-width: 330px;
      justify-self: center;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      @include breakpoint(tablet) {
        max-width: 343px;
        justify-self: normal;
      }
      &__img {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        width: 100%;
        max-width: 100%;
        @include breakpoint(tablet) {
          height: 250px;
          object-fit: cover;
        }
      }
      &__description {
        padding: 15px;
        &__text {
          color: $--color-primary;
          font-size: 19px;
          font-weight: 700;
          margin-bottom: 20px;
          :deep(h4) {
            text-transform: none;
          }
        }
        &__button {
          width: 100%;
        }
        &__toggle {
          width: 100%;
          color: $--color-primary;
          margin-top: 0.8em;
          :deep(h4) {
            color: $--color-primary;
          }
        }
      }
    }
  }
}
</style>
